<template>
  <div class="progress-bar-container relative clearfix" ref="progressBar" id="progress-bar">
    <div class="step-title">Step {{ currentStep }}</div>
    <div class="progress-bar-wrap">
      <div class="progress-bar" :style="styles"></div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex"

export default {
  name: "ProgressBar",

  computed: {
    ...mapState("survey", [
      "currentStep",
      "totalSteps",
    ]),

    styles() {
      const percent = Math.floor((this.currentStep / this.totalSteps) * 100);

      return {
        width: `${percent}%`,
      };
    },
  },

  mounted() {
    setTimeout(() => this.$refs.progressBar.classList.add("in"), 100);
  },
}
</script>

<style lang="scss">
$progress-bar-font-size: $font-size-small;
$progress-bar-bg: $color-alabaster;
$progress-bar-color: $color-pizazz;

.progress-bar-container {
  height: 0;
  opacity: 0;
  transition: opacity 800ms ease-in-out, height 400ms ease-in-out;
  overflow: hidden;

  &.in {
    height: 16px;
    opacity: 1;
  }
}

.step-title {
  float: left;
  letter-spacing: 0.025rem;
  font-size: $progress-bar-font-size;
}

.progress-bar-wrap {
  position: relative;
  height: 2px;
  top: 0.45rem;
  left: 1rem;
  width: auto;
  margin-right: 1rem;
  background-color: $progress-bar-bg;
  border-radius: 2px;
  overflow: auto;
}

.progress-bar {
  height: 2px;
  background: linear-gradient(to right,#ffccf6 0%,#ff7ea2 50%,#ff8b02 100%);
  border-radius: 2px;
  transition: width 500ms ease-in-out;
}
</style>
